import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Camera, CameraOptions } from "@ionic-native/camera/ngx";
import { FileUploadService } from '../services/file-upload.service'; 
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  NavController,
  Platform,
  ToastController,
} from "@ionic/angular";
import { ActivatedRoute, Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import { AppintmentData } from "../models/AppintmentData";
import { Helper } from "../services/Helper";
import { APIService } from "../services/APIService";
import { Network } from "@ionic-native/network/ngx";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { Chooser } from "@ionic-native/chooser/ngx";

//import { AnyARecord } from "dns";

@Component({
  selector: "app-appointment-form",
  templateUrl: "./appointment-form.page.html",
  styleUrls: ["./appointment-form.page.scss"],
})
export class AppointmentFormPage implements OnInit {

   // Variable to store shortLink from api response 
   shortLink: string = ""; 
   loading: boolean = false; // Flag variable 
   file: File = null; // Variable to store file 

  credentialsForm: FormGroup;
  Regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  // date:any
  // time:any
  // dateTime:any;

  fname: any;
  lname: any;
  email: any;
  phone: any;
  gender: any;
  dob: any;
   firstname:any;
   lastname:any;
   consulting_fee:any;
   profilepicture:any;
   checked: any;
  flag: false;
  appinfo: AppintmentData;
  loader: any;
  imageData: any;
  fileType: any;
  fileName: any;
  imgsrc: any;
  base64Image: any;
  private win: any = window;
  docconsulting_fee:any;
//docfirstname:any;
  doclastname:any;
  docspeciality:any;
  clinicaddress:any;
  clinicname:any;
  docprofilepicture:any;
  docqualification:any;
  docId:any;

  type:any;
  posts: any;
  items: any;

  constructor(
    private formBuilder: FormBuilder,
    private Router: Router,
    private camera: Camera,
    public actionSheetController: ActionSheetController,
    private storage: Storage,
    private router: Router,
    public toastController: ToastController,
    private network: Network,
    public loadingController: LoadingController,
    public helper: Helper,
    private apiservice: APIService,
    private splashScreen: SplashScreen,
    private alertCtrl: AlertController,
    private platform: Platform,
    private chooser: Chooser,
    private fileUploadService: FileUploadService
  ) {
    this.credentialsForm = this.formBuilder.group({
      fname: ["", Validators.compose([Validators.required])],
      lname: ["", Validators.compose([Validators.required])],
      email: ["", [Validators.required, Validators.email]],
      mobile: [
        "",
        Validators.compose([
          Validators.pattern(this.Regex),
          Validators.required,
        ]),
      ],
      notes: ["", Validators.compose([Validators.required])],
    });

    this.appinfo = new AppintmentData();
    this.checked = false;
  }

  ngOnInit() {
          
   }

   onChange(event) { 
    this.file = event.target.files[0]; 
} 

   getAllPosts() {
    this.presentLoading().then(() => {
      this.apiservice.getspecificDoctor({_teamId: this.docId}).subscribe(
        (response: any) => {
          this.posts = response.body.result; 
          console.log('Doctor-Fee',response.body.result.consulting_fee);
          this.storage.set('docfee',response.body.result.consulting_fee);
          console.log("posts",this.posts);
          
          this.dismissLoading();
        },
        (error) => {
          this.dismissLoading();
          this.helper.presentToastError("Something went wrong!");
        }
      );
    });
  }
   

  ionViewWillEnter() {


    let params = new URLSearchParams(window.location.search);
    this.docId = params.get("docId");
    this.storage.set('docNewId',this.docId);
    console.log("this.docId",this.docId);
    
     if(this.docId){     
        this.getAllPosts();
     }
  }


  segmentChanged(event) {
    if (event.detail.value == "Self") {
    
      this.type = "Self";
      this.toggle();
      //this.self();
     
    }
    if (event.detail.value == "Others") {
    
      this.type = "Others";
      this.others();
    
    }
  }

  toggle() {
    this.checked = !this.checked;

    if (this.checked) {
      this.fname = this.appinfo.firstname;
      this.lname = this.appinfo.lastname;
      this.email = this.appinfo.email;
      this.phone = this.appinfo.phone;
      this.dob = this.appinfo.dob;
      this.gender = this.appinfo.gender;
    }
    // if (!this.checked) {
    //   this.fname = "";
    //   this.lname = "";
    //   this.email = "";
    //   this.phone = "";
    //   this.dob = "";
    //   this.gender = "";
    // }
  }

  self(){
   
  
     
        this.fname = this.appinfo.firstname;
        this.lname = this.appinfo.lastname;
        this.email = this.appinfo.email;
        this.phone = this.appinfo.phone;
        this.dob = this.appinfo.dob;
        this.gender = this.appinfo.gender;
      
    
       }

       others(){
          this.fname = "";
          this.lname = "";
          this.email = "";
          this.phone = "";
          this.dob = "";
          this.gender = "";
        }
      

      
  

  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: "Select Using",
      buttons: [
        // {
        //   text: "Camera",
        //   handler: () => {
        //     this.takephoto();
        //   },
        // },
        // {
        //   text: "Gallery",
        //   handler: () => {
        //     this.selectPhoto();
        //   },
        // },
        // {
        //   text: "File",
        //   handler: () => {
        //     this.onUpload();
        //   },
        // },
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {},
        },
      ],
    });
    await actionSheet.present();
  }

  takephoto() {
    // this.imageData ="file:///9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAAeABYDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAcGCAkK/8QAJhAAAwABBAIDAAIDAQAAAAAAAQIDBAUGEhMHEQAIFCIkCSEjQf/EABcBAAMBAAAAAAAAAAAAAAAAAAECBAD/xAAmEQEAAQIFBAEFAAAAAAAAAAABEQIhAxIxQVEAImGRUgQTstHw/9oADAMBAAIRAxEAPwCsH088aY29de0PBOMkq5GZp6UxWx0PZZTS6SqrFBwF6pdVRoNahApRiaT+dC/2Z+g6eKfB+k731CWD15emxNoT6WycbItiNlGNxkyTqFpKOYxy5Hri4VgHXmV+rvm0bV1TSM3GyxOqGFZEWmljdeDFXJAH/KkVfHYAlVdCTxb181K81f5AN3eRvH2k6Du/eefqek4SNjaZjVy3bGw6ZaY2NjoslBYplCQM+ZKI3Y7lf0synB+oqw8JoqKCotT2U3nLbUhzQszMIX6pqo+5XnmRYqFuAERHN/Us9YxfYrbPDcM8edMDE68jJ7q/llc0dPSzDSZ/cmBayf6avucZK7+kkXPi+81b0nrWvG0MiuW/fke/0ISJoK1dQpmy+m42QP7J9sCf/PSnyRx8VZaC/ig3pmJOX3HHTGFS3VvfV3hONo2NuL1F2bvPP04hkPWxDhWL0LYk1YIylwCjVV1n2qXm6TIHoBeRbjeV86mF+Y6if7KOynmVkkHFcelJdpBVevHpi44CksaT4nlUMtO9t/YjxlOVL6rtLW3l/XlkHF0zRqO0qCsYWSL63jTaqTllcovQcWpMrlOFHXKB9jPFL42MRtbc1J9UK465Gl6G3CUse7ZErSluCWPRawvDHCiSq6oxcKiCVXWBKqM0zVLVtqtzg0ve5oTjLNPcyoJD+/HPFjTqX69vjMz7LJMj9iks4jTJxsZkWH8RSlmZR3F8qq1iQHJ/n6IUkHxMa15l2DX8ndt3WutoCk3TF05aPyC+qVnLVYFKWTibL+iyo6AK1FKmZ8Rm3a6Hxfi6qP8AchJml1fy8efHuOL/AP/Z"

    this.presentLoading().then(() => {
      const options: CameraOptions = {
        quality: 100,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
      };

      this.camera.getPicture(options).then(
        (imageData) => {
          // this.cropImage(imageData)

          this.imageData = imageData;
          this.fileType = 1;

          this.imgsrc = this.win.Ionic.WebView.convertFileSrc(imageData);

         // this.image=(<any>window).Ionic.WebView.convertFileSrc(imageData);
          console.log("imageData", this.imageData);

          console.log("imgsrc", this.imageData);
          this.base64Image = "data:image/jpeg;base64," + imageData;

          this.dismissLoading();

          // console.log("image",this.image)
          // this.upload();
        },
        (err) => {
          // Handle error
          alert("error " + JSON.stringify(err));
          this.dismissLoading();
        }
      );
    });
  }

  selectPhoto(): void {
    this.presentLoading().then(() => {
      const optionsGallery: CameraOptions = {
        quality: 100,
        sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.PNG,
        mediaType: this.camera.MediaType.PICTURE,
      };
      this.camera.getPicture(optionsGallery).then(
        (imageData) => {
          this.imageData = imageData;
          this.fileType = 1;

          // this.imgsrc = this.win.Ionic.WebView.convertFileSrc(imageData);
          // this.base64Image = "data:image/jpeg;base64," + imageData;

          // this.image=(<any>window).Ionic.WebView.convertFileSrc(imageData);
          console.log("imageData", this.imageData);

          this.dismissLoading();

          // console.log("image",this.image)
          // this.upload();
        },
        (err) => {
          // Handle error
          alert("error " + JSON.stringify(err));
          this.dismissLoading();
        }
      );
    });
  }

  selectFile() {
    this.chooser
      .getFile()
      .then((file) => {
        console.log("fileData", file);
        if (file) {
          this.fileName = file.name;
          this.imageData = file.dataURI;
          console.log("this.imageData", this.imageData);
          this.fileType = 2;
        }
      })
      .catch((error: any) => console.error(error));
  }

  next(value: any) {
    if (!value.fname || !this.credentialsForm.controls.fname) {
      this.helper.presentToast("Please Enter First Name!");
    } else if (!value.lname || !this.credentialsForm.controls.lname) {
      this.helper.presentToast("Please Enter Last Name!");
    } else if (!value.email || !this.credentialsForm.controls.email) {
      this.helper.presentToast("Please Enter Email address!");
    } else if (!value.mobile || !this.credentialsForm.controls.mobile) {
      this.helper.presentToast("Please Enter Mobile Number!");
    } else if (!value.notes || !this.credentialsForm.controls.notes) {
      this.helper.presentToast("Please Enter Notes!");
    } else if (!this.gender) {
      this.helper.presentToast("Please Enter gender");
    } else if (!this.dob) {
      this.helper.presentToast("Please Enter date of Birth");
    } else {
      console.log(value);

      const patinetAppData = {
        firstname: value.fname,
        lastname: value.lname,
        dob: this.dob,
        age: this.dob,
        gender: this.gender,
        email: value.email,
        phone: value.mobile,
        notes: value.notes,
        imageData: this.imageData,
        fileType: this.fileType,
        fileName: this.file,
      };

      if (this.flag) {
        console.log("flag true", this.flag);
        this.storage.set("self", 1);
      } else {
        console.log("flag false", this.flag);
        this.storage.set("self", 0);
      }

      console.log("patinetAppData", patinetAppData);
      this.storage.set("patinetAppData", patinetAppData);
      this.router.navigate(["/all-slots"]);
    }
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({
      translucent: true,
    });
    await this.loader.present();
  }

  async dismissLoading() {
    await this.loader.dismiss();
  }

  onUpload(event) { 

    this.file = event.target.files[0];
    this.loading = !this.loading; 
    console.log(this.file);
    const reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = () => {
        console.log(reader.result);
        this.imageData = reader.result;
        this.fileType=1
    };  
} 

handleUpload(event) {
  const file = event.target.files[0];
  console.log("dp",this.file);
  
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
      console.log(reader.result);
  };
}
}
